import { Controller } from "@hotwired/stimulus";
import { postMessageToPreviewIframes } from "../lib/preview_iframe_messaging";

// On a successful turbo form submission, post a `refresh-preview` message
// to every iframe in the page. The iframe's preview script (in
// previews/show.html.erb) handles the message via
// `Turbo.session.refresh(document.baseURI)`, which honors the
// `turbo-refresh-method: morph` meta — so scroll position and focus are
// preserved. This replaces the old `broadcast_refresh_to` path: the
// ActionCable broadcast still ends up calling refresh, but in practice the
// iframe scrolled to the top on save (the morph meta wasn't reliably
// applied to the broadcast path). postMessage takes the same path the
// simple editor uses for its live-update flow, so the two editors behave
// the same on save.
export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-end", this.#onSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.#onSubmitEnd);
  }

  #onSubmitEnd = (event) => {
    if (!event.detail?.success) return;
    postMessageToPreviewIframes({ type: "refresh-preview" });
  };
}
